import { render, staticRenderFns } from "./SpaceCabinet.vue?vue&type=template&id=761763c0&"
import script from "./SpaceCabinet.vue?vue&type=script&lang=js&"
export * from "./SpaceCabinet.vue?vue&type=script&lang=js&"
import style0 from "./SpaceCabinet.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports